import {Component, Input, OnInit} from '@angular/core';
import {
    CategoryItem,
    Country,
    League, LeagueEvents, LeagueRaceType, LeagueStandingsMeta,
    LeagueStandingsViewMode,
    Lookups,
} from "@model";
import {AbstractComponent} from "@components";

@Component({
    selector: 'app-league-results-tab',
    templateUrl: './league-results-tab.component.html',
    styleUrl: './league-results-tab.component.scss',
    standalone: false
})
export class LeagueResultsTabComponent extends AbstractComponent implements OnInit {
    @Input() standingsMeta: LeagueStandingsMeta[] = [];
    @Input({required: true}) league?: League;
    @Input({required: true}) countries: Country[] = [];
    @Input({ required: true }) languages: Lookups[] = [];
    @Input() gender: number | undefined = undefined;
    @Input() categoryItems: CategoryItem[] = [];
    @Input() competitorsCountries: Country[] = [];
    @Input() leagueEvents?: LeagueEvents;

    currentStandingsMeta: LeagueStandingsMeta | undefined;
    activeRaceType: LeagueRaceType = LeagueRaceType.INDIVIDUAL;
    availableRaceTypes: LeagueRaceType[] = [];
    constructor() {
        super();
    }

    ngOnInit() {
        this.standingsMeta.forEach(meta => {
            if (!meta.raceType) return;
            this.availableRaceTypes.push(meta.raceType)
        })
        if (this.availableRaceTypes.length) {
            this.onRaceTypeChange(this.availableRaceTypes.at(0) ?? LeagueRaceType.INDIVIDUAL )
        }
    }

    private updateStandingsMeta(raceType: LeagueRaceType) {
        this.currentStandingsMeta = this.standingsMeta.find(
            m => m.raceType === raceType
        );
    }

    onRaceTypeChange(raceType: LeagueRaceType) {
        this.activeRaceType = raceType;
        this.updateStandingsMeta(raceType);
    }

    protected readonly LeagueStandingsViewMode = LeagueStandingsViewMode;
}